import React from 'react';

import type { ProduitType } from '@/types';

export type ProduitContextType = {
  produits: ProduitType[];
  loading: boolean;
  refresh: () => void;
};

const ProduitsContext = React.createContext<ProduitContextType>({
  produits: [],
  loading: false,
  refresh: () => {},
});

export default ProduitsContext;
